const stack = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: '0 0 20px 20px',
    '& .stacking-card:last-child': {
        flex: 1,
        borderRadius: 0,
    },
};
const mobileCard = {
    borderRadius: '0 0 20px 20px',
    boxShadow: 'none',
    marginTop: '-20px',
    paddingTop: '20px',
    width: '100%',
};
const desktopCard = {
    boxShadow: 'none',
    width: '100%',
};
export default {
    stack,
    mobileCard,
    desktopCard,
};
